import { hasPermissionByRouteName } from "../router/permissions";
import {
  hasCasinoGamesEnabled,
  hasLotteryEnabled,
} from "~/plugins/config";
import {
  navItems as sportsBetMenuItems,
  navUserItems as sportsBetUserMenuItems
} from "packages/sports-bet/resources/js/routes/menu-routes";
import { navItems as lotteryMenuItems } from "packages/lottery/resources/js/routes/menu-routes";
import { navItems as userTrackingMenuItems } from "packages/user-tracking/resources/js/routes/menu-routes";

export const navAdminItems = [
  !hasPermissionByRouteName("admin.dashboard.index")
    ? null
    : {
        to: { name: "admin.dashboard.index" },
        icon: "mdi-view-dashboard",
        title: "Dashboard"
      },
  !hasPermissionByRouteName("admin.my-dashboard.index")
    ? null
    : {
        to: { name: "admin.my-dashboard.index" },
        icon: "mdi-view-dashboard-variant",
        title: "My panel"
      },
  !hasPermissionByRouteName("admin.users.index")
    ? null
    : {
        to: { name: "admin.users.index" },
        icon: "mdi-account-multiple",
        title: "Users"
      },
  !hasPermissionByRouteName("admin.accounts.index")
    ? null
    : {
        to: { name: "admin.accounts.index" },
        icon: "mdi-account-cash",
        title: "Accounts"
      },
  !hasPermissionByRouteName("admin.manual-transactions.index")
    ? null
    : {
        to: { name: "admin.manual-transactions.index" },
        icon: "mdi-cash-100",
        title: "Manual Transactions"
      },
  !hasPermissionByRouteName("admin.deposits.dashboard")
    ? null
    : {
        to: { name: "admin.deposits.dashboard" },
        icon: "mdi-cash-plus",
        title: "Deposits"
      },
  !hasPermissionByRouteName("admin.withdrawals.dashboard")
    ? null
    : {
        to: { name: "admin.withdrawals.dashboard" },
        icon: "mdi-cash-minus",
        title: "Withdrawals"
      },
  hasCasinoGamesEnabled() && hasPermissionByRouteName("admin.games.index")
    ? {
        to: { name: "admin.games.index" },
        icon: "mdi-cards-playing-outline",
        title: "Games"
      }
    : null,

  ...lotteryMenuItems,
  ...sportsBetMenuItems,
  ...userTrackingMenuItems,

  !hasPermissionByRouteName("admin.reports.index")
    ? null
    : {
        to: { name: "admin.reports.index" },
        icon: "mdi-file-chart",
        title: "Reports"
      },
  !hasPermissionByRouteName("admin.support-tickets.index")
    ? null
    : {
        to: { name: "admin.support-tickets.index" },
        icon: "mdi-face-agent",
        title: "Support Tickets"
      },
  !hasPermissionByRouteName("other")
    ? null
    : {
        icon: "mdi-form-dropdown",
        title: "Others",
        hasChildren: true,
        children: [
          !hasPermissionByRouteName("admin.affiliate.index")
            ? null
            : {
                to: { name: "admin.affiliate.index" },
                icon: "mdi-link",
                title: "Affiliates"
              },
          !hasPermissionByRouteName("admin.payment-banks.index")
            ? null
            : {
                to: { name: "admin.payment-banks.index" },
                icon: "mdi-bank",
                title: "Banks"
              },
          !hasPermissionByRouteName("admin.generic-transactions.dashboard")
            ? null
            : {
                to: { name: "admin.generic-transactions.dashboard" },
                icon: "mdi-cash-minus",
                title: "Generic Transactions"
              },
          // !hasPermissionByRouteName('admin.sites.index') ? null : {
          //     to: {name: 'admin.sites.index'},
          //     icon: 'mdi-web',
          //     title: 'Sites',
          // },
          !hasPermissionByRouteName("admin.deposit-methods.index")
            ? null
            : {
                to: { name: "admin.deposit-methods.index" },
                icon: "mdi-cash-marker",
                title: "Deposit methods"
              },
          !hasPermissionByRouteName("admin.withdrawal-methods.index")
            ? null
            : {
                to: { name: "admin.withdrawal-methods.index" },
                icon: "mdi-cash-marker",
                title: "Withdrawal methods"
              },
          !hasPermissionByRouteName("admin.chat.index")
            ? null
            : {
                to: { name: "admin.chat.index" },
                icon: "mdi-message-outline",
                title: "Chat"
              },
          !hasPermissionByRouteName("admin.license.index")
            ? null
            : {
                to: { name: "admin.license.index" },
                icon: "mdi-license",
                title: "License registration"
              },
          !hasPermissionByRouteName("admin.add-ons.index")
            ? null
            : {
                to: { name: "admin.add-ons.index" },
                icon: "mdi-shape",
                title: "Add-ons"
              },
          !hasPermissionByRouteName("admin.maintenance.index")
            ? null
            : {
                to: { name: "admin.maintenance.index" },
                icon: "mdi-server",
                title: "Maintenance"
              }
        ].filter(item => !!item)
      },
  !hasPermissionByRouteName("admin.settings.index")
    ? null
    : {
        to: { name: "admin.settings.index" },
        icon: "mdi-cog",
        title: "Settings"
      }
].filter(item => !!item);

export const navUserItems = [
  {
    to: { name: "home" },
    icon: "mdi-home",
    title: "Home"
  },
  !hasPermissionByRouteName("tutorial.list")
    ? null
    : {
        to: { name: "tutorial.list" },
        icon: "mdi-server",
        title: "Tutorials"
      },
  !hasPermissionByRouteName("support")
    ? null
    : {
        to: { name: "support" },
        icon: "mdi-help",
        title: "Support"
      }
].filter(item => !!item);

export const navAuthUserItems = [
  !hasPermissionByRouteName("user.account.deposits.index")
    ? null
    : {
        to: { name: "user.account.deposits.index" },
        icon: "mdi-cash-plus",
        title: "Deposits"
      },
  !hasPermissionByRouteName("user.account.withdrawals.index")
    ? null
    : {
        to: { name: "user.account.withdrawals.index" },
        icon: "mdi-cash-minus",
        title: "Withdrawals"
      },
  hasLotteryEnabled() &&
  hasPermissionByRouteName("user.lottery.tickets.tickets-in-process")
    ? {
        to: { name: "user.lottery.tickets.tickets-in-process" },
        icon: "mdi-ticket",
        title: "Lottery"
      }
    : null,

  // Menus del Sports bets
  ...sportsBetUserMenuItems,

  !hasPermissionByRouteName("history")
    ? null
    : {
        to: { name: "history" },
        icon: "mdi-history",
        title: "History"
      },
  !hasPermissionByRouteName("leaderboard")
    ? null
    : {
        to: { name: "leaderboard" },
        icon: "mdi-star",
        title: "Leaderboard"
      }
].filter(item => !!item);

export const externalGames = [
  // {
  //     id: 'egames-american-roulette',
  //     to: {name: 'e-games.american-roulette-3d', params: { game: 'e-games-american-roulette-3d' }},
  //     icon: 'mdi-view-dashboard',
  //     title: 'American Roulette 3D',
  // },
].filter(item => !!item);
